/**
 * Starting values for a NEW pipeline schedule.
 *
 * These live in their own module for two reasons: exporting constants from a
 * component file breaks React Fast Refresh, and keeping them apart from the
 * form makes it obvious that they are applied in exactly one place — the
 * create branch of the dialog's hydrate effect. The edit branch reads every
 * field from the saved schedule instead, so changing a default here can never
 * rewrite an existing schedule.
 */

/**
 * The orchestrator's own default run mode.
 *
 * Omitting `run_mode` from the wire is how a schedule inherits the server's
 * choice, and that is the *only* reason `buildPipelineConfig` guards the key.
 * Deliberately separate from `NEW_SCHEDULE_DEFAULTS.runMode`: both were the
 * literal `'auto'` before, so changing the form's default would silently have
 * changed which keys got sent.
 */
export const SERVER_DEFAULT_RUN_MODE = 'auto' as const;

export const NEW_SCHEDULE_DEFAULTS = {
  /** Central Time — where most dealer operations sit. */
  timeZone: 'America/Chicago',
  /** 2 AM local: after overnight inventory feeds, before the service day. */
  hour: 2,
  /**
   * Sunday and Wednesday. Every one of the 14 live schedules uses exactly this
   * pair, so it is the observed convention rather than a guess.
   */
  daysOfWeek: [0, 3] as readonly number[],
  /**
   * Scheduled refreshes want a complete re-crawl rather than the
   * orchestrator's delta heuristic, matching the Run Pipeline dialog.
   * Note this costs a full crawl on every firing.
   */
  runMode: 'full' as const,
  notifyOnSuccess: true,
  notifyOnFailure: true,
  notificationEmails: ['engineering@kebi.ai'],
  minIntervalMinutes: 60
};
